import { useCallback, useState } from 'react';
import { useToggleFreeMode } from './use-toggle-free-mode';

interface DistractionState {
  active: boolean;
  exit: () => void;
  enter: () => void;
}
export const DistractionFreeMode = '__distractionFree';

export const useDistractionFreeMode = (
  key: string | undefined = undefined,
): DistractionState => {
  const [distractionFreeActive, setDistractionFreeActive] = useState(false);

  const onToggle = useCallback((value: boolean) => {
    setDistractionFreeActive(value);
  }, []);

  const { active, exit, enter } = useToggleFreeMode({
    active: distractionFreeActive,
    localStorageKey: key ?? DistractionFreeMode,
    onToggle,
  });

  return {
    active,
    exit,
    enter,
  };
};
